<p-table
	#dtc
	[(selection)]="selectedTasks"
	[paginator]="true"
	[rows]="20"
	[showCurrentPageReport]="true"
	[value]="taskList"
	dataKey="processId"
	styleClass="p-datatable-tyalls p-datatable-gridlines p-datatable-striped datatable-sm"
>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="name">
				Workflow Name
				<p-sortIcon field="name"></p-sortIcon>
			</th>
			<th></th>
			<th pSortableColumn="isComplete">
				Task Status
				<p-sortIcon field="isComplete"></p-sortIcon>
			</th>
			@if(isPhobosEnabled){
				<th pSortableColumn="aiStatus">
					AI Status
					<p-sortIcon field="aiStatus"></p-sortIcon>
				</th>
			}
			@if (showDueDate()) {
				<th>
					Due Date
					<p-sortIcon field="dueDate"></p-sortIcon>
				</th>
			}
			<th pSortableColumn="assignedTo">
				Currently With
				<p-sortIcon field="assignedTo"></p-sortIcon>
			</th>
			<th pSortableColumn="launchedBy">
				Uploaded By
				<p-sortIcon field="launchedBy"></p-sortIcon>
			</th>
		</tr>
	</ng-template>
	<ng-template let-task pTemplate="body">
		<tr>
			<td class="workflow-badge-row">
				<span class="p-column-title">Name</span>
				<p-badge
					[className]="this.getWorkFlowClass(task)"
					[pTooltip]="this.getToolTipText(task)"
				></p-badge>
				{{ task.name }}
			</td>
			<td class="button-col">
				<button
					(click)="this.goToTask(task, $event)"
					class="p-button-rounded"
					label="Go to Task"
					pButton
					pRipple
					type="button"
				></button>
			</td>
			@if (task.isComplete) {
				<td  class="column-element-center">
					<i class="pi pi-check green-tick"></i>
				</td>
			} @else {
				<td class="column-element-center">
					<i class="pi pi-times red-tick"></i>
				</td>
			}
			@if (isPhobosEnabled && task.isAIEnabled) {
				<td>
					<span>

						@if(task.isValid){
							@if(task.isAutoCompleted){
								<span class="p-tag p-tag-success">
									Auto Completed
								</span>
							}@else{
								@if(task.isAtRisk){
									<span  class="p-tag p-tag-warning">
												At Risk
									</span>
								}
							}
						} @else {
							<span class="p-tag p-tag-danger">
									Alert
						</span>
						}

					</span>
				</td>
			}@else {
			<td></td>
			}
			@if (showDueDate()) {
				<td>{{ task.dueDate  | DateLocalFormat: false }}</td>
			}
			<td>{{ task.assignedDisplayName }}</td>
			<td>{{ task.launchedBy }}</td>
		</tr>
	</ng-template>

	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="8">No tasks found</td>
		</tr>
	</ng-template>
</p-table>
